import React, { useEffect } from 'react';
import { ActionButton } from '@icarros/ids-react';
import { useProposalsContext } from '../../../store/contexts/proposals';
import { SideContainerWrapper } from '../../../styles/sideContainerStyles';
import { EmptyDetails } from './EmptyDetails';
import { Message } from './Message';

export function Details(): JSX.Element {
  const { currentProposal, setCurrentProposal, transition, setTransition } = useProposalsContext();

  useEffect(() => {
    setTransition(false);
  }, [currentProposal, setTransition]);

  function closeEditPage() {
    setTransition(true);
    setTimeout(() => {
      setCurrentProposal(undefined);
    }, 300);
  }

  return (
    <SideContainerWrapper isOpen={!!currentProposal} isTransition={transition}>
      {!!currentProposal && (
        <ActionButton
          variant="neutral"
          weight="small"
          text="voltar"
          iconName="itaufonts_seta"
          onClick={() => closeEditPage()}
        />
      )}
      {!currentProposal && <EmptyDetails />}

      {!!currentProposal && <Message />}
    </SideContainerWrapper>
  );
}
